/** Vertical gap between stacked location labels (box height + margin). */
export const LOCATION_BOX_STEP_PX = 76;

export interface StackableLocationBox {
  runId: string;
  anchorX: number;
  topY: number;
  above: boolean;
  isPart: boolean;
  startMs: number;
}

/** Rail placement is authoritative; overlap uses z-index, not vertical offsets. */
export function resolveLocationBoxStacks(
  boxes: readonly StackableLocationBox[],
): Map<string, { anchorX: number; topY: number }> {
  const resolved = new Map<string, { anchorX: number; topY: number }>();
  for (const box of boxes) {
    resolved.set(box.runId, { anchorX: box.anchorX, topY: box.topY });
  }
  return resolved;
}
